<template>
  <div id="loginPage" class=" p-sm-0">
    <div v-if="!isLoggedIn" class="container-fluid">
      <div class="splash-screen ">
        <div class="splash-img">
          <v-img :src="getImgUrl('logo.svg')" class="shadow rounded-circle" max-height="150">
          </v-img>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div v-if=" isLoaded && banner.length > 0" class="row">
        <div class="col-md-6 col-sm-10 col-12 mx-auto">
          <carousel
              :autoplay="true"
              :dots="false"
              :items="1"
              :margin="5"
              :nav="false"
              :rtl="true">
            <div v-for="item in banner"
                 :key="item.BanerID">
              <img v-if="item.FileUrl !==null" :src="$replaceHttps(item.FileUrl)" alt="بنر" class="img-fluid"
                   @click="openLink(item.Link)">
            </div>
          </carousel>
        </div>
      </div>
      <div class="row p-3 pt-0">
        <v-card
            class=" p-4 my-2 mx-auto rounded-xl  col-md-6 col-sm-10 col-12 mx-auto">
          <div class="text-center font20px"><img alt="لوگو" class="navImg" height="100"
                                                 src="../assets/img/pishroLogo.png"/></div>
          <div class="my-3 primary-text font16px">ورود</div>
          <div class="my-2"><i class="fas fa-user ml-1"></i> نام کاربری:</div>
          <v-text-field
              v-model="userName"
              class="input-border"
              dense
              hide-details
              solo
              type="text">
          </v-text-field>
          <div class="my-2"><i class="fas fa-lock ml-1"></i> رمز عبور:</div>
          <v-text-field
              v-model="password"
              class="input-border"
              dense
              hide-details
              solo
              type="password">
          </v-text-field>
          <div class="primary-text font-weight-bold my-3" @click="openForgetPassModal = true"> فراموشی رمز عبور
          </div>
          <div>
            <v-btn block class="purple-gradient-btn" rounded @click="login">
              <i class="fas fa-sign-in-alt ml-2"></i>ورود
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="openForgetPassModal"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="my-2 black--text"><i class="fas fa-mobile ml-1 primary-text"></i> شماره موبایل:</div>
          <v-text-field
              v-model="forgetPasswordMobile"
              :rules="phoneNumberRules"
              class="input-border"
              dense
              solo
              type="number">
          </v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn :disabled="forgetPasswordMobile.length < 11" class="primary" rounded @click="recoverPassword">
            بازیابی رمزعبور
          </v-btn>
          <v-btn color="primary" outlined rounded @click="openForgetPassModal = !openForgetPassModal">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;

import carousel from 'xx-vue-owl-carousel';

export default {
  name: "Login",
  metaInfo: {
    title: 'مسیربرتر-ورود'
  },
  components: {
    carousel
  },
  data: () => ({
    forgetPasswordMobile: '',
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: '',
    password: null,
    userName: null,
    banner: [],
    isLoaded: false,
    studentID: null,
    appUserId: null,
    token: null,
    isLoggedIn: false,
    openForgetPassModal: false,
    phoneNumberRules: [
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
  }),
  mounted() {
    _this = this;
    this.silentLogin()


  },
  methods: {
    silentLogin() {
      let loggedInUserData = this.$getUserData();
      if(loggedInUserData.userName !== '' && loggedInUserData.password !== '') {

        let myHeaders = new Headers();
        var formdata = new FormData();


        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        formdata.append("UserName", loggedInUserData.userName);
        formdata.append("Password", loggedInUserData.password);

        fetch(this.$baseUrl + "Home/Login", requestOptions)
            .then(response => {
              if (response.status === 200) {
                return response.text();
              } else {
                _this.getData()
                _this.isLoggedIn = true

              }
            })
            .then(result => {
              let jsonResponse = JSON.parse(result);
              if (jsonResponse) {
                _this.token = 'Bearer ' + jsonResponse.JwtToken;
                _this.userName = loggedInUserData.userName;
                _this.password = loggedInUserData.password
                _this.getIDs()
              }

            })
            .catch(error => {
              (console.log('errorsilent', error))
            });
      }else {
        _this.getData()
        _this.isLoggedIn = true
        let _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/)
        if (_iOSDevice) {
          this.$addToHomescreen.mount({
            lang: "en_GB",
            buttonColor: "#8057EF",
            title: 'وب اپلیکیشن مسیر برتر',
            iconPath: 'https://masirebartarapp.com/favicon.ico',
            content: 'مسیر برتر را به صفحه اصلی موبایل خود اضافه کنید'

          });
        }
      }

    },
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Login", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.banner = json.Baners.filter(x=>x.IsActive ===true)
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    login() {
      _this.showLoaderDialog = true
      let myHeaders = new Headers();
      let formdata = new FormData();
      formdata.append("UserName", this.userName);
      formdata.append("Password", this.password);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Login", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            if (result.indexOf('نام کاربری یا رمز عبور اشتباه است') > -1) {
              _this.showResultDialog = true;
              _this.dialogResult = result
            } else {
              let json = JSON.parse(result)
              _this.token = 'Bearer ' + json.JwtToken
              _this.getIDs()
            }
          })
          .catch(error => {
            _this.showLoaderDialog = false
            _this.dialogResult = error
            _this.showResultDialog = true;
            console.log('error', error)
          });
    },
    getIDs() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "MyProfile/StudentProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            _this.appUserId = json.AppUserID;
            _this.studentID = json.StudentProfileID
            _this.getStudentInfo()

          })
          .catch(error => console.log('error', error));
    },
    getStudentInfo() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "MyProfile/Individual", requestOptions)
          .then(response => response.text())
          .then(result => {

            let json = (JSON.parse(result));
            let jsonModel= json.model

            _this.$setUserData(_this.userName, _this.password, _this.token, _this.appUserId, _this.studentID, jsonModel.Name, jsonModel.Family, jsonModel.FileUrl,json.Grade,json.Class);
            _this.$setUserLogo(jsonModel.FileUrl);
            setTimeout(function () {
              _this.$router.replace({path: 'LoggedIn'})
            }, 1000)
          })
          .catch(error => console.log('error', error));
    },
    openLink(link) {
      if (link !== null) {
        _this.$openLink(link)
      }
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToHome() {
      this.$router.push({path: 'LoggedIn'})
    },
    recoverPassword() {
      this.openForgetPassModal = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.forgetPasswordMobile);
      urlencoded.append("Email", "");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/RecoveryPasswordBySms", requestOptions)
          .then(result => {
            if (result.status === 200) {
              result.text().then(text => {
                _this.showLoaderDialog = false;
                _this.showResultDialog = true;
                _this.dialogResult = text
              })
            } else {
              result.text().then(text => {
                let json = JSON.parse(text)
                _this.showLoaderDialog = false;
                _this.showResultDialog = true;
                _this.dialogResult = (json.Public)[0]
              })
            }
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>